import { useTranslation } from "react-i18next";
import { apiRequest } from "@/lib/queryClient";
import {cashRefusal,cashUnexpected} from "@shared/cash-request-errors";

export function useCashLanguage() {
  const { i18n } = useTranslation();
  const ar = i18n.language.startsWith("ar");
  return { ar, text: (en: string, arabic: string) => ar ? arabic : en };
}
export async function workbenchRequest<T>(method: string, url: string, body?: unknown): Promise<T> {
  const response = await apiRequest(method, url, body);
  return response.json();
}
export function workbenchError(error: unknown, ar: boolean) {
  let message = error instanceof Error ? error.message : "";
  const raw=message.replace(/^\d{3}:\s*/,"");
  try {
    const body=JSON.parse(raw);
    if(typeof body.message==="string")message=body.message;
  } catch {}
  message=cashRefusal(message);
  if(message.includes(" / "))return message;
  if(/^\s*[{[]|^\d{3}:|Unable to complete|Failed query|constraint|SQL|Internal Server/i.test(message))
    return cashUnexpected("CASH-UNAVAILABLE");
  if (!ar) return message || "The request failed. Please retry.";
  if (/401|session|log in/i.test(message)) return "انتهت الجلسة. أعد تسجيل الدخول ثم حاول مجدداً.";
  if (/403|permission|denied|authorized/i.test(message)) return "ليس لديك صلاحية لهذا الإجراء أو لهذا الفرع.";
  if (/409|sequence|changed|stale|snapshot/i.test(message)) return "تغيّرت البيانات أو انتهت صلاحية العرض. حدّث الصفحة وراجع البيانات قبل المحاولة.";
  if (/400|422|invalid|required/i.test(message)) return "تعذّر قبول البيانات. راجع الحقول المطلوبة وتاريخ الاستحقاق والمستخدم المحدد.";
  if (/offline|network|fetch/i.test(message)) return "تعذّر الاتصال بالخادم. تحقق من اتصال الإنترنت وحاول مجدداً.";
  return "تعذّر تنفيذ الطلب. لم يتم تأكيد نجاح العملية. حاول مجدداً أو تواصل مع المسؤول.";
}
export function cashDate(value: string | null | undefined) {
  return value ? new Intl.DateTimeFormat("en-GB", { timeZone: "Africa/Cairo", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(value)) : "—";
}
export function cashNumber(value: string | number | null | undefined) {
  return value == null ? "—" : Number(value).toLocaleString("en-US", { maximumFractionDigits: 2 });
}